import { v4 as uuidv4 } from 'uuid';
import {
  ADD_NOTIFICATION,
  CLOSE_NOTIFICATION,
  CLOSE_UI_MODAL,
  END_REQUEST_LOADING,
  GET_TAB_VALUE,
  OPEN_UI_MODAL,
  PUSH_ROUTE,
  RESET_FORM_VALUES,
  START_REQUEST_LOADING,
  UPDATE_FORM_VALUE,
  UPDATE_TAB_VALUE,
} from './types';

/**
 * Action to handle notification addition.
 */
export function addNotification(config: object) {
  return {
    type: ADD_NOTIFICATION,
    payload: {
      id: uuidv4(),
      ...config,
    },
  };
}

/**
 * Action to handle notification closures.
 */
export function closeNotification(id: string) {
  return {
    type: CLOSE_NOTIFICATION,
    payload: id,
  };
}

/**
 * Action to push to a different route.
 */
export function pushRoute(history, route: string, delay = 0) {
  return {
    type: PUSH_ROUTE,
    payload: { history, route, delay },
  };
}

export const startRequestLoading = (payload: string) => ({
  type: START_REQUEST_LOADING,
  payload,
});

export const endRequestLoading = (payload: string) => ({
  type: END_REQUEST_LOADING,
  payload,
});

export const openModalAction = (payload: { type: string; payload: any }) => ({
  type: OPEN_UI_MODAL,
  payload,
});

export const closeModalAction = (
  payload: { type: string; payload: any } = { type: '', payload: {} }
) => ({
  type: CLOSE_UI_MODAL,
  payload,
});

export const updateFormValue = (payload: {fieldName: string; value: string}) =>({
  type: UPDATE_FORM_VALUE,
  payload
});

export const resetFormValue = (payload: any) => ({
  type: RESET_FORM_VALUES,
  payload
})

export const setTabValue = (payload: any) => ({
  type: UPDATE_TAB_VALUE,
  payload
})

export const getTabValue = (payload: any) => ({
  type: GET_TAB_VALUE,
  payload
})